import '../node_modules/bootstrap/dist/css/bootstrap-grid.css'
import './theme/scripts/index'
import './theme/styles/index.scss'
import '@af-utils/scrollend-polyfill'
